import React from 'react';

// Matches a markdown link [label](https://…) or a bare https?:// URL. Only
// http(s) is ever turned into a link, so a model-written `javascript:` URL
// stays plain text.
const LINK_RE = /\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s<>()]+)/g;
// Punctuation that ends a sentence rather than the URL ("see https://x.com.").
const TRAILING_PUNCT_RE = /[.,;:!?'"]+$/;

const LINK_CLASS = 'text-brand-blue underline hover:text-brand-blue/80 break-all';

function anchor(href, label, key) {
  return (
    <a key={key} href={href} target="_blank" rel="noopener noreferrer" className={LINK_CLASS}>
      {label}
    </a>
  );
}

// Splits plain chat text into strings and <a> nodes for markdown links and
// bare URLs. Everything else is left untouched (the bubble keeps
// whitespace-pre-wrap for line breaks and bullets).
export function linkify(text) {
  if (!text) return text;
  const nodes = [];
  let last = 0;
  let key = 0;
  for (const m of text.matchAll(LINK_RE)) {
    const [whole, label, mdHref, bare] = m;
    let end = m.index + whole.length;
    if (m.index > last) nodes.push(text.slice(last, m.index));
    if (mdHref) {
      nodes.push(anchor(mdHref, label, key++));
    } else {
      const trailing = bare.match(TRAILING_PUNCT_RE)?.[0] || '';
      const href = trailing ? bare.slice(0, -trailing.length) : bare;
      end -= trailing.length;
      nodes.push(anchor(href, href, key++));
    }
    last = end;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
}
